import type { Messages } from './messages';

export const en = {
  common: {
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    submitting: 'Submitting…',
    cancel: 'Cancel',
    loading: 'Loading…',
    retry: 'Retry',
    required: 'Required',
    close: 'Close',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    error: 'Error',
    tryAgain: 'Please try again.',
    networkError:
      'Network problem. Please check your connection and try again — nothing was submitted twice.',
  },
  shopStatus: {
    open: 'Open',
    closedToday: 'Closed today',
    beforeOpen: 'Opening soon',
    afterClose: 'Closed for the day',
    registrationCutoff: 'Walk-in registration is closed for today',
    manuallyPaused: 'Not accepting walk-ins right now',
    manuallyClosed: 'Not accepting walk-ins right now',
    walkInsAvailable: 'Walk-ins available',
    walkInsClosed: 'Walk-in registration is closed',
  },
  barbers: {
    nextAvailable: 'Next Available',
    noneAvailable: 'No barbers are currently accepting new customers.',
    label: 'Barber preference',
  },
  checkIn: {
    title: 'Join the Walk-In List',
    subtitle: 'Enter your phone number to get started — it only takes a few seconds.',
    phoneLabel: 'Phone number',
    phonePlaceholder: '(980) 255-8167',
    lookupButton: 'Continue',
    welcomeBack: 'Welcome back, {{name}}.',
    notYou: 'Not you?',
    updateInfo: 'Update my information',
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    emailLabel: 'Email',
    marketingConsentLabel:
      'Send me occasional Nine80 Hair Studio news, offers and promotions by email.',
    submitButton: 'Join the list',
    honeypotLabel: 'Leave this field blank',
    errorInvalidPhone: 'Enter a valid 10-digit U.S. phone number.',
    errorInvalidEmail: 'Enter a valid email address.',
    errorInvalidName: 'Please enter a valid name.',
    errorQueueClosed:
      'Walk-in registration has closed for today. Please see a staff member if you’re already at the shop.',
    errorBarberUnavailable:
      'That barber is no longer accepting new customers. Please pick another barber or Next Available.',
    errorAlreadyOnList: "You're already on the list.",
    confirmationTitle: "You're on the list.",
    confirmationRequested: 'Requested: {{barber}}',
    confirmationAhead: '{{count}} customers currently ahead of you.',
    confirmationAheadSingular: '{{count}} customer currently ahead of you.',
    confirmationRemoteHint:
      'When you arrive, open this page and tap "I’m Here," or let a staff member know.',
    confirmationViewStatus: 'View my status',
  },
  status: {
    title: 'Your Walk-In Status',
    requestedFor: 'Requested: {{barber}}',
    aheadPlural: '{{count}} customers currently ahead of you.',
    aheadSingular: '{{count}} customer currently ahead of you.',
    aheadZero: "You're next up among your eligible barbers.",
    presentYes: "You're marked present at the shop.",
    presentNo: "We don't have you marked as arrived yet.",
    imHereButton: "I'm Here",
    imHereConfirmed: "Thanks — you're marked as arrived.",
    cancelButton: 'Leave the walk-in list',
    cancelConfirmTitle: 'Leave the walk-in list?',
    cancelConfirmBody: "You'll lose your place in line. You can always rejoin later.",
    cancelled: "You've left the walk-in list.",
    statusWaiting: 'Waiting',
    statusInChair: 'In the chair',
    statusCompleted: 'Completed — thanks for coming in!',
    statusNoShow: 'Marked as no-show',
    statusCancelled: 'Cancelled',
    statusRemoved: 'Removed from the list',
    contactTitle: 'Nine80 Hair Studio',
  },
  kiosk: {
    welcomeTitle: 'Welcome to Nine80 Hair Studio',
    welcomeSubtitle: 'Tap below to check in for a walk-in haircut.',
    checkInButton: 'Check In',
    queueTitle: 'Currently waiting',
    noOneWaiting: 'No one is currently waiting. Walk in? Check in below.',
    staffAccess: 'Staff',
    languageToggle: 'Español',
    inactivityPrompt: 'Still there?',
    inactivityContinue: 'Yes, continue',
    confirmationTitle: "You're checked in!",
    confirmationBody: 'A staff member will call your name when it’s your turn.',
    returningPrompt: 'Welcome back!',
    newCustomerPrompt: "Looks like you're new here.",
  },
  staff: {
    loginTitle: 'Staff Sign In',
    pinLabel: 'PIN',
    loginButton: 'Sign In',
    loggingIn: 'Signing in…',
    invalidPin: 'Incorrect PIN.',
    rateLimited: 'Too many attempts. Please wait a few minutes and try again.',
    logoutButton: 'Sign Out',
    queueTitle: 'Walk-In Queue',
    emptyQueue: 'Queue is clear.',
    present: 'Present',
    markPresent: 'Mark Present',
    inChairButton: 'In Chair',
    completeButton: 'Complete',
    noShowButton: 'No Show',
    removeButton: 'Remove',
    reassignLabel: 'Barber',
    barberStatusLabel: 'Status',
    statusAvailable: 'Available',
    statusOnBreak: 'On Break',
    statusDoneForDay: 'Done for Day',
    waitingMinutes: '{{minutes}}m waiting',
    actingAsLabel: 'Acting as',
    selectBarberPrompt: 'Select a barber',
    alreadyTaken: 'This customer has already been taken by another barber.',
    confirmRemoveTitle: 'Remove this customer?',
    confirmRemoveBody: 'This removes them from the active queue. The visit stays on record.',
    languageToggle: 'Español',
  },
} satisfies Messages;
